import React, { useState, useEffect, createContext, useContext } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { useFlags } from "launchdarkly-react-client-sdk";
import { sendTealiumView } from "../helpers";
import { AppStore } from "../app/store";

const initialState = "";
export const ReferrerContext = createContext(initialState);

const ReferrerDetector: React.FunctionComponent<RouteComponentProps> = ({
  location: { pathname },
  children,
}) => {
  const { state } = useContext(AppStore.AppContext);
  const [previousLocation, setPreviousLocation] = useState("");
  const [goBackTextId, setGoBackTextId] = useState(initialState);
  const { mctCurrentPlanYear } = useFlags();

  useEffect(() => {
    if (previousLocation !== pathname) {
      setPreviousLocation(pathname);

      switch (previousLocation) {
        case "/search-results":
          setGoBackTextId("app.terms.go_back_to_search_results");
          break;
        case "/compare-plans":
          setGoBackTextId("app.terms.go_back_to_plan_compare");
          break;
        default:
          setGoBackTextId("app.terms.start_a_new_search");
          break;
      }
    }

    if (state.tealiumLoaded) {
      sendTealiumView(
        pathname
          .replace("/", "")
          .split("/", 1)
          .join("")
          .replace(/-/g, " "),
        state,
        mctCurrentPlanYear
      );
    }
  }, [pathname, state.tealiumLoaded]);

  return (
    <ReferrerContext.Provider value={goBackTextId}>
      {children}
    </ReferrerContext.Provider>
  );
};

export default withRouter(ReferrerDetector);
